import { mapEntityProperties } from '@/utils/mapEntityProperties'
import { CreateUpdateCategoryEntity } from '../../domain/entities/CreateUpdateCategoryEntity'
import { CategoryLevel } from '../../domain/enums/CategoryLevel'
import type { FileUploadEntity } from '@/shared/entities/FileUploadEntity'
import moment from 'moment'

export class CreateUpdateCategoryModel extends CreateUpdateCategoryEntity {
  level = CategoryLevel.ROOT
  translations = []
  branchId!: number
  parentCategoryId?: number | null
  icon?: FileUploadEntity | null

  constructor(dataDto: CreateUpdateCategoryEntity) {
    super()
    mapEntityProperties<CreateUpdateCategoryModel>(this, dataDto, {
      exclude: ['imageData', 'imageUrl', 'branch', 'parentCategory'],
      map: {
        icon: dataDto?.imageData?.removeFile ? { removeFile: true } : dataDto?.imageData,
        branchId: dataDto.branch?.id,
        parentCategoryId: dataDto.parentCategory?.id,
        startTime: dataDto.startTime
          ? /^([0-1]?[0-9]|2[0-3]):[0-5][0-9]$/.test(dataDto.startTime)
            ? moment(`2000-01-01 ${dataDto.startTime}`).utc().format('HH:mm')
            : moment(new Date(dataDto.startTime)).utc().format('HH:mm')
          : null,
        endTime: dataDto.endTime
          ? /^([0-1]?[0-9]|2[0-3]):[0-5][0-9]$/.test(dataDto.endTime)
            ? moment(`2000-01-01 ${dataDto.endTime}`).utc().format('HH:mm')
            : moment(new Date(dataDto.endTime)).utc().format('HH:mm')
          : null
      }
    })
  }
}
